import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Custom Modules
import { PipesModule } from '../../pipes/pipes.module';

// Declared Directive
import { WPFeaturedMediaBackgroundDirective } from './featured-media-background.directive';

@NgModule({
    imports: [
        CommonModule,
        PipesModule,
    ],
    declarations: [
        WPFeaturedMediaBackgroundDirective,
    ],
    exports: [
        WPFeaturedMediaBackgroundDirective,
    ]
})
export class WPFeaturedMediaBackgroundModule {}
